import type { IResponse } from '@/utils';
import { ObjectKeyToLine } from '@/utils';
import { request } from '@/utils';
import type { RequestOptionsInit } from 'umi-request';

// 1.15版本更新内容
// 行为验证码
export enum CaptchaType {
  'default',
  'register',
  'modify_password',
  'send_vcode',
}

export interface ICaptchaRes extends IResponse {
  data: {
    new_captcha: string;
    gt: string;
    success: number;
    challenge: string;
  };
}

export async function getInitCaptcha(scene?: CaptchaType) {
  return request.get<ICaptchaRes>(
    scene ? `/user/init_captcha?scene=${scene}` : '/user/init_captcha',
  );
}

interface ISendSMSReqParams {
  operationType: any;
  oldChallenge: string;
  geetestChallenge: string;
  geetestValidate: string;
  geetestSeccode: string;
}

interface ISendSMSRes extends IResponse {
  data: {
    mobile: string;
    send_status: number;
    send_message: string;
  };
}
interface ISendSMSReq extends ISendSMSReqParams {
  mobile: string;
  forceSend: 1;
}
export async function sendSMSRequest(params: ISendSMSReq) {
  return request.post<ISendSMSRes>('/user/apply_code', {
    data: ObjectKeyToLine(params),
  });
}
interface ISendSMSEmailReq extends ISendSMSReqParams {
  email: string;
}
export async function sendSMSEmailRequest(params: ISendSMSEmailReq) {
  return request.post<ISendSMSRes>('/user/apply_code_email', {
    data: ObjectKeyToLine(params),
  });
}

interface ICheckMobileRes extends IResponse {
  data: {
    /**
     * 0:不存在
     * 1: 存在
     */
    exist: 0 | 1;
    is_bind_recom_code: 0 | 1; // 该账户已绑定推荐码
  };
}

export async function checkMobile(mobile: string) {
  return request.post<ICheckMobileRes>('/user/is_mobile_exist', {
    data: {
      mobile,
    },
  });
}

interface ILoginResponse extends IResponse {
  data: {
    account: string;
    token: string;
    mobile?: string | number;
    [key: string]: any;
  };
}

// 1.15版本登录
export interface ILoginReqProps {
  account?: string;
  password?: string;
  mobile?: string;
  verifyCode?: string;
  version?: string;
  channel?: string;
  channel_robot?: string | number;
  launch_from?: string;
  geetestChallenge?: string;
  geetestValidate?: string;
  geetestSeccode?: string;
}

export async function loginAccount(params: ILoginReqProps) {
  return request.post<ILoginResponse>('/user/login', {
    data: ObjectKeyToLine(params),
  });
}
interface IcheckPramas {
  version: string;
  account: string;
}

interface IcheckRespon {
  msg: string;
  data: {
    version: string;
  };
  code: number;
}
export async function checkPrivacyPolicy(params: IcheckPramas, options?: RequestOptionsInit) {
  return request.post<IcheckRespon>('/user/privacy/agree', {
    ...options,
    data: params,
  });
}

export async function getPrivacyPolicy(account: string, options?: RequestOptionsInit) {
  return request.get<IcheckRespon>(`/user/privacy/version?account=${account}`, options);
}

interface IRegisterProps {
  account: string;
  password: string;
  mobile_dc?: string;
  mobile: string;
  verifyCode: string;
  company: string;
  recomCode: string;
  cuid?: string;
  amazonToken?: string;
  channel?: string;
}

interface IRegisterResProps extends IResponse {
  data: {
    token: string;
    account: string;
    mobile: string;
    name: string;
    is_newly_created: number;
    [key: string]: any;
  };
}

export async function registerAccount(params: Partial<IRegisterProps>) {
  return request.post<IRegisterResProps>('/user/register', {
    data: ObjectKeyToLine(params),
  });
}

export async function registerAWSAccount(params: Partial<IRegisterProps>) {
  return request.post<IRegisterResProps>('/api/proxy/aws/customer/register/v1/registerByMobile', {
    prefix: window.location.origin,
    data: ObjectKeyToLine(params),
  });
}

export interface IVerifyMobile {
  mobile: string;
  verify_code: string;
  target_api: string;
}
interface IVerifyRespones extends IResponse {
  data: {
    credential: string;
  };
}
export async function verifyMobileService(params: IVerifyMobile) {
  return request<IVerifyRespones>('/user/credential/verify_mobile', {
    method: 'POST',
    data: params,
  });
}
export async function postForgetPwd(params: {
  /**
   * @description
   * 1 手机号
   * 2 邮箱
   */
  verify_type: 1 | 2;
  verify_value: string;
  password: string;
  credential: string;
}) {
  return request.post<IResponse>('/service/user/forget_password', {
    data: params,
  });
}
export interface ICredentialRes extends IResponse {
  data: { credential: string };
}

/**
 * @description  手机号验证生成凭证
 */
export async function postVerifyMobile(params: { mobile: string; verify_code: string }) {
  return request.post<ICredentialRes>('/user/credential/verify_mobile', {
    data: {
      ...params,
      target_api: '/service/user/forget_password',
    },
  });
}
/**
 * @description  手机号验证生成凭证
 */
/**
 * @description 邮箱验证生成凭证
 */
export async function postVerifyEmail(params: { email: string; verify_code: string }) {
  return request.post<ICredentialRes>('/user/credential/verify_email', {
    data: {
      ...params,
      target_api: '/service/user/forget_password',
    },
  });
}

export interface IVerifyEmail {
  email: string;
  verify_code: string;
  target_api: string;
}

export async function verifyEmailService(params: IVerifyEmail) {
  return request<IVerifyRespones>('/user/credential/verify_email', {
    method: 'POST',
    data: params,
  });
}
export async function loginWidthSSO(token: string) {
  return request.post<ILoginResponse>('/user/sso/verify_token', {
    data: {
      sso_token: token,
    },
  });
}
interface IPlatformIdResponse extends IResponse {
  data: string;
}

export async function getPlatformId() {
  return request.get<IPlatformIdResponse>('/user/sso/get_platform_id');
}
interface EmailExistServiceReq {
  email: string;
}
export async function verifyEmailExist(data: EmailExistServiceReq) {
  return request.post<ICheckMobileRes>('/user/is_email_exist', {
    data,
  });
}
